import { useCallback } from "react";
import { useParams } from "react-router-dom";

import { TOUR_QUERY_PARAM } from "@/components/Playground/tour/hooks/useTourUrlParam";
import { posthogTrackTourStarted } from "@/components/Playground/tour/posthog";
import { routePaths } from "@/utils/routePaths";

/**
 * Returns a callback that opens the standalone playground in a new tab
 * with `?tour` set, so the user's saved-prompt context (PromptTemplate
 * page) stays untouched. No-ops if the workspaceId is not in the URL.
 */
export const useOpenPlaygroundTourInNewTab = (): (() => void) => {
  const { workspaceId } = useParams();

  return useCallback(() => {
    if (!workspaceId) {
      return;
    }
    posthogTrackTourStarted({ source: "prompt-template-header" });
    const url = routePaths.workspacePlayground(workspaceId, `?${TOUR_QUERY_PARAM}`);
    window.open(url, "_blank", "noopener,noreferrer");
  }, [workspaceId]);
};
